var React = require('react');

function WhiteCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.67241 18.3234C8.20418 18.3234 7.75936 18.1276 7.43159 17.7848L0.80608 10.8554C0.12714 10.1453 0.12714 8.96997 0.80608 8.25989C1.48502 7.54981 2.60878 7.54981 3.28772 8.25989L8.67241 13.8916L20.706 1.306C21.385 0.595917 22.5087 0.595917 23.1877 1.306C23.8666 2.01608 23.8666 3.19138 23.1877 3.90146L9.91323 17.7848C9.58547 18.1276 9.14065 18.3234 8.67241 18.3234Z","fill":"white"}));
}

WhiteCheck.defaultProps = {"width":"24","height":"19","viewBox":"0 0 24 19","fill":"none"};

module.exports = WhiteCheck;

WhiteCheck.default = WhiteCheck;
